module.exports = __webpack_public_path__ + "img/banner1.a655acdd.jpg";